var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreenCheckmark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 48,
    viewBox: "0 0 48 48",
    width: 48,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    stroke: "#719b25",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.6085075 14.6544183-2.8913325-2.5431393c-.0887172-.0785319-.2066352-.1184672-.3229929-.1102124-.1179181.0078086-.2280344.0620224-.306052.15104l-10.4869038 11.9462179-3.7287959-4.9397006c-.0711074-.0941491-.1769885-.1563945-.2940149-.1724578-.1168035-.017402-.236059.0142785-.3301259.0858942l-3.0712189 2.3220453c-.1963814.1485859-.2353902.4283557-.0869339.6249086l6.9043354 9.1462882c.0806925.1068658.2055206.1720116.3392651.1769198h.0162723c.1279488 0 .2501021-.0548831.3350299-.1517093l13.9638142-15.9065009c.1627225-.1849515.144667-.4671755-.0403462-.6295937z",
    fill: "#719b25",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheckmark);
export default __webpack_public_path__ + "static/media/green-checkmark.a13471df0984c51fdd209dff21efec32.svg";
export { ForwardRef as ReactComponent };